class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
    this.openOnHover = this.openOnHover.bind(this);
    this.closeOnHover = this.closeOnHover.bind(this);
    this.onNestedItemEnter = this.onNestedItemEnter.bind(this);

    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.bindHoverEvents(this.hoverMediaQuery.matches);
    this.hoverMediaQuery.addEventListener('change', (event) => this.bindHoverEvents(event.matches));
  }

  bindHoverEvents(enable) {
    this.removeEventListener('mouseenter', this.openOnHover);
    this.removeEventListener('mouseleave', this.closeOnHover);
    this.querySelectorAll('.header__submenu > li').forEach((item) => {
      item.removeEventListener('mouseenter', this.onNestedItemEnter);
    });

    if (!enable) return;

    this.addEventListener('mouseenter', this.openOnHover);
    this.addEventListener('mouseleave', this.closeOnHover);
    this.querySelectorAll('.header__submenu > li').forEach((item) => {
      item.addEventListener('mouseenter', this.onNestedItemEnter);
    });
  }

  openOnHover() {
    clearTimeout(this.closeTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  closeOnHover() {
    this.closeTimeout = setTimeout(() => {
      this.close();
      this.closeNestedMenus();
    }, 120);
  }

  onNestedItemEnter(event) {
    const currentDetails = event.currentTarget.querySelector(':scope > details');

    this.querySelectorAll('.header__submenu > li > details[open]').forEach((details) => {
      if (details === currentDetails) return;
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });

    if (!currentDetails) return;
    currentDetails.setAttribute('open', '');
    currentDetails.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  closeNestedMenus() {
    this.querySelectorAll('.header__submenu details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
